export default class accordionFaq {

	static init() {

		$('.list-domande .item').click(function () {
			$(this).toggleClass('open');
			$('.open').not(this).removeClass('open');
		});

	}

}
